export default "__VITE_ASSET__94bfc906__"